import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Trigger = styled.button.attrs({ className: 'language-switcher' })`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  background-color: var(--darkGreen-800);
  border: none;
  border-radius: var(--icon-button-radius);
  color: var(--antiFlashWhite1);
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  line-height: 1;

  &:hover {
    background-color: var(--darkSlateGray2);
  }

  .dsc-icon-wrapper {
    color: inherit;
  }
`;

export const NativeLabel = styled.span`
  font-weight: 600;
`;

export const SubLabel = styled.span`
  margin-left: auto;
  font-size: 11px;
  color: var(--cadetGray, #8aa0a8);
`;

export const OptionRow = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;
